import Keycloak from 'keycloak-js';

// These placeholder strings are replaced at container runtime by entrypoint.sh
const getEnvVar = (placeholder, envVar, fallback) => {
  if (placeholder.startsWith('__')) {
    return envVar || fallback;
  }
  return placeholder;
};

const keycloakConfig = {
  url: getEnvVar("__REACT_APP_KEYCLOAK_URL__", process.env.REACT_APP_KEYCLOAK_URL, "https://keycloak.m0008.cathexislabs.io"),
  realm: getEnvVar("__REACT_APP_KEYCLOAK_REALM__", process.env.REACT_APP_KEYCLOAK_REALM, "argus"),
  clientId: getEnvVar("__REACT_APP_KEYCLOAK_CLIENT_ID__", process.env.REACT_APP_KEYCLOAK_CLIENT_ID, "argus-ui"),
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
